import { BaseUrl } from "../../BaseUrl/BaseUrl";
import { postApiWithAuthorization } from "../ApiMethod/ApiMethod";

const base = `${BaseUrl}/razorpay`
export const createDevOrder = async (params) => {
    const url = `${base}/create-Dev-order`;
    const res = await postApiWithAuthorization(url, params);
    return res;
};
export const verifyDevPayment = async (params) => {
    const url = `${base}/verify-Dev-payment`;
    const res = await postApiWithAuthorization(url, params);
    return res;
};